import React, { Component } from 'react';

import './Contacts.css';
import ListContacts from './ListContacts';
import EditContact from './EditContact';
import AddContact from './AddContact';

class ContactForm extends Component {

    isFormBlank(array) {
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    render() {
        return (<>
            {(this.props.justAdd == null || !this.props.justAdd) && this.props.contacts.map((row, rowIndex) => (
                <div key={row.linkedID}>
                    {this.props.editID !== row.linkedID ? (
                        <ListContacts {...this.props} row={row}
                        />
                    ) : (
                        <EditContact {...this.props} row={row}
                            isFormBlank={this.isFormBlank}
                        />
                    )
                    }
                    {(rowIndex < this.props.contacts.length - 1) ? <hr className='border-dark' /> : <></>}
                </div>
            ))}
            {((this.props.justAdd)) ? (
                <AddContact {...this.props}
                    isFormBlank={this.isFormBlank}
                />
            ) : (<></>)}

        </>
        );

    }

}

export default ContactForm;
